// adminClient.js -- internal admin console at /m01-p/naked/sourcemap/ops-console-3d7a/ (staff only)